// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var Utils       = require("./Utils");
var Json_decode = require("@glennsl/bs-json/lib/js/src/Json_decode.js");
var Json_encode = require("@glennsl/bs-json/lib/js/src/Json_encode.js");

function create(cid, $staropt$star, _) {
  var name = $staropt$star ? $staropt$star[0] : "";
  return /* record */[
          /* cid */cid,
          /* name */name
        ];
}

function encode(param) {
  return Json_encode.object_(/* :: */[
              /* tuple */[
                "cid",
                param[/* cid */0]
              ],
              /* :: */[
                /* tuple */[
                  "name",
                  param[/* name */1]
                ],
                /* [] */0
              ]
            ]);
}

function decode(json) {
  return /* record */[
          /* cid */Json_decode.field("cid", Json_decode.string, json),
          /* name */Json_decode.field("name", Json_decode.string, json)
        ];
}

var cidToString = Utils.identity;

var cidFromString = Utils.identity;

exports.create        = create;
exports.cidToString   = cidToString;
exports.cidFromString = cidFromString;
exports.encode        = encode;
exports.decode        = decode;
/* Json_encode Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/Card.re
// module id = 12
// module chunks = 0